export default function Fog(props) {
    return <>
        <color args={[0xFFFFFF]} attach="background" />
        <fog attach="fog" color={0xFFFFFF} near={6} far={8} />
    </>
}